module.exports = {
  get: () => new Promise(() => {}),
  put: () => new Promise(() => {}),
  post: () => new Promise(() => {}),
};
